import React, { Component, PureComponent } from "react";
import platform from "Pub/js/platform";
import DefdocListGridRef from "Components/Refers/DefdocListGridRef";
import { createScript } from "./utilService";
const { base, high } = platform;
const {
    NCInput,
    NCFormControl,
    NCRadio,
    NCCheckbox,
    NCSelect,
    NCSwitch,
    NCDatePicker,
    NCNumber,
    NCBetweenNum,
    NCTextArea,
    NCTZDatePickerStart,
    NCTZDatePickerRangeDay,
    NCTZDatePickClientHourTime,
    NCTZDatePickClientTime,
    NCTimepicker,
    NCTZDatePickerEnd,
    NCDatePickerNoTimeZone,
    NCRangePicker,
} = base;
const { Refer } = high;
const RadioGroup = NCRadio.NCRadioGroup;
const Option = NCSelect.NCOption;

/**
 * 渲染区域字段类型
 *
 * @param {*} item - 字段属性
 * @param {*} type - 区域类型
 * @param {*} multiLang - 多语
 * @returns
 */
export function getItemTypeCom(item, type, multiLang, showName) {
    const { disabled, label, onClick } = item;
    const showSelectArr = ['radio', 'checkbox_switch', 'checkbox', 'switch_browse', 'switch']; //查询区需要显示成select的字段
    let itemDisabled = item.disabled;
    let itemOptions = item.datatype === '32' ?
        [`${multiLang['ZoneSetting-000229']}=Y`, `${multiLang['ZoneSetting-000230']}=N`]
        : item.showdataval && item.showdataval.split(","); //逻辑options为是否
    const commonProps = {
        disabled,
        // placeholder: type === 'search' && label, //查询区字段增加placeholder
        placeholder: type === 'search' && showName || '', //查询区字段增加placeholder
        onClick,
    };
    let result = {
        input: (<NCInput onChange={() => { }} {...commonProps} />),
        residtxt: (<NCInput onChange={() => { }} {...commonProps} />), //多语文本
        password: (
            <NCFormControl
                value={this.state.passwordValue}
                onChange={val => this.setState({ passwordValue: val.split("").fill("●").join("") })} //将输入的内容填充成●
                {...commonProps}
            />), // 这里不用密码框是因为原生密码框不能拖拽
        label: (<NCFormControl isViewMode={true} {...commonProps} />),
        number: (() => {
            let scale = -1;
            if (item.queryOperateType === "between") {
                return (
                    <NCBetweenNum
                        start={{
                            scale: Number(scale),
                            max: item.max,
                            min: item.min,
                            placeholder: "起始",
                        }}
                        end={{
                            scale: Number(scale),
                            max: item.max,
                            min: item.min,
                            placeholder: "结束",
                        }}
                    />
                );
            } else {
                return (
                    <NCNumber
                        max={item.max}
                        min={item.min}
                        suffix={item.suffix}
                        scale={Number(scale)}
                        formNumber={true}
                        {...commonProps}
                    />
                );
            }
        })(),
        textarea: (<NCTextArea style={{ resize: 'none' }} {...commonProps} />),
        radio: (() => {
            let radioItem = <NCRadio
                color="info"
                disabled={itemDisabled}
            />;
            if (itemOptions && itemOptions.length > 0) {
                radioItem = itemOptions.map((item, i) => {
                    let ops = item.indexOf("=") > 0 ? item.split("=") : [];
                    return (
                        <NCRadio
                            color="info"
                            disabled={itemDisabled}
                            value={ops[1]}
                            key={i}
                        >
                            {ops[0]}
                        </NCRadio>
                    );
                });
            }
            return <RadioGroup
                selectedValue={this.state.radioSelectedValue}
                onChange={val => this.setState({ radioSelectedValue: val })}
            >
                {radioItem}
            </RadioGroup>;
        })(),
        checkbox_switch: (
            <NCCheckbox
                className="single-checkbox"
                disabled={itemDisabled}
                colors="primary"
                type="switch"
            />
        ),
        checkbox: (() => {
            if (itemOptions) {
                return itemOptions && itemOptions.map((item, i) => {
                    let ops = item.indexOf("=") > 0 ? item.split("=") : [];
                    return <NCCheckbox
                        disabled={itemDisabled}
                        colors="primary"
                        // checked={e.checked}
                        key={i}
                    >
                        {ops[0]}
                    </NCCheckbox>;
                });

            } else {
                return <NCCheckbox
                    className="single-checkbox"
                    disabled={itemDisabled}
                    colors="primary"
                />;
            }
        })(),
        NCTZDatePickerStart: (<div className="item-wrapper"><NCTZDatePickerStart {...commonProps} /></div>),
        NCTZDatePickerRangeDay: (
            <div className="item-wrapper">
                <NCTZDatePickerRangeDay
                    format={item.format || "YYYY-MM-DD HH:mm:ss"}
                    {...commonProps}
                />
            </div>
        ),
        NCTZDatePickClientHourTime: (
            <div className="item-wrapper">
                <NCTZDatePickClientHourTime
                    format={item.format || 'YYYY-MM-DD HH:mm:ss'}
                    {...commonProps}
                />
            </div>
        ),
        datetimepicker: (<div className="item-wrapper"><NCTZDatePickClientTime {...commonProps} /></div>),
        timepicker: (<div className="item-wrapper"><NCTimepicker format={"HH:mm:ss"} {...commonProps} /></div>),
        NCTZDatePickerEnd: (<div className="item-wrapper"><NCTZDatePickerEnd {...commonProps} /></div>),
        datePickerNoTimeZone: (<div className="item-wrapper"><NCDatePickerNoTimeZone {...commonProps} /></div>),
        rangepicker: (<div className="item-wrapper"><NCRangePicker {...commonProps} /></div>),
        select: (
            <div className="item-wrapper">
                <NCSelect
                    multiple={!!item.isMultiSelectedEnabled}
                    labelInValue={true}
                    {...commonProps}
                >
                    {itemOptions &&
                        itemOptions.map((item, i) => {
                            let ops = item.indexOf("=") > 0 ? item.split("=") : [];
                            return <Option
                                title={ops[0]}
                                value={ops[1]}
                                key={i}
                            >
                                {ops[0]}
                            </Option>;
                        })}
                </NCSelect>
            </div>
        ),
        datepicker: (<div className="item-wrapper"><NCDatePicker {...commonProps} /></div>),
        switch_browse: (<NCSwitch disabled={itemDisabled} />),
        switch: (<NCSwitch disabled={itemDisabled} />),
        refer: (<BaseRefer item={item} {...commonProps} />),
        attachment: (<i className='iconfont icon-danchuang' />),
    };
    let newItemType = type === 'search' && showSelectArr.includes(item.itemtype) ? 'select' : item.itemtype; //查询区枚举显示成下拉
    return result[newItemType];
}
class BaseRefer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { defaultvalueObj: {} };
    }

    renderRefer = () => {
        const { item, ...otherProps } = this.props;
        const { refcode } = this.props.item;
        //自定义档案
        if (item.datatype === "57") {
            return <DefdocListGridRef placeholder="" showHistory={false} {...otherProps}
            />;
        } else {
            if (this.state[`myRefDom${refcode}`]) {
                const MyRef = this.state[`myRefDom${refcode}`];
                return (
                    <MyRef
                        foolValue={this.state.defaultvalueObj}
                        onChange={(ref, foolValue) => {
                            this.setState({
                                defaultvalueObj: foolValue,
                                // defaultvalueObj: {...ref, ...foolValue}
                            });
                        }}
                        showHistory={false}
                        {...otherProps}
                    />
                );
            } else {
                //参照默认取值相对路径改为绝对路径
                createScript.call(this, `${refcode}`);
            }
        }
    }
    //渲染虚拟参照
    renderFakeRefer = () => (
        <div
            className={`refer-wrapper ${this.props.disabled ? 'refer-wrapper-disabled' : ''}`}
            onMouseEnter={this.renderRefer}
        >
            <div className="refer" style={{ backgroundColor: window.nccColor == 'black' ? 'unset' : this.props.disabled ? '#f3f3f3' : '#fff' }}>
                <div className="base-form-control-wrapper refer-input">
                    <input type="text" className="nc-input wui-input md" placeholder={this.props.placeholder} disabled={this.props.disabled} />
                </div>
                <i className="icon-refer" style={{ cursor: 'pointer' }}></i>
            </div>
            {/* 加载参照 */}
        </div>
    )

    render() {
        const { item } = this.props;
        let finalRefer;
        if (item.visible) { //显示的属性加载参照
            finalRefer = item.refcode ? this.renderRefer() : this.renderFakeRefer();
        } else {
            if (this.state[`myRefDom${item.refcode}`]) { //加载隐藏属性的参照
                finalRefer = this.renderRefer();
            } else { //隐藏的属性默认不加载参照
                finalRefer = this.renderFakeRefer();
            }
        }
        //解决有refcode仍然没有加载参照的问题
        if (!finalRefer) {finalRefer = this.renderFakeRefer();}
        return <div>{finalRefer}</div>;
    }
}
